/* Import main stylesheet */
import "./main.scss";

/* Import JS */
import CarouselPolos from "./js/CarouselPolos";
import CarouselCategories from "./js/CarouselCategories";
import CarouselEpisodes from "./js/CarouselEpisodes";
import CarouselEducators from "./js/CarouselEducators";
import UserAgent from "./js/UserAgent";

/* Init functions */
CarouselPolos();
CarouselCategories();
CarouselEpisodes();
CarouselEducators();
UserAgent();
